module.exports = __webpack_public_path__ + "img/slide_notice_mail.8eb15f31.svg";